import type {StoreApi} from 'zustand/vanilla';

import type {Nullish} from 'shared/web';

import {VIRTUAL_PRESET_ID} from '../../constants/VIRTUAL_PRESET_ID';
import type {ActionsAlignment} from '../../types/ActionsAlignment';
import type {GetDataQueryResponse, TransformedDefinitionApiResponse} from '../../types/Api';
import {loadPinnedPresetIds, loadPresetDisplayMode} from '../../utils/presetLocalPrefs';
import type {EagGridState, EagGridStore} from '../createEagGridStore';

type CoreActions = Pick<
  EagGridStore,
  'setDataQuery' | 'setDefinition' | 'setApiError' | 'initStaticConfig'
>;

/** Core grid + static-config actions. Bodies moved verbatim from createEagGridStore.ts. */
export function createCoreActions(store: StoreApi<EagGridState>): CoreActions {
  return {
    setDataQuery: (dataQuery: GetDataQueryResponse | Nullish) => {
      store.setState({dataQuery});
    },

    setDefinition: (definition: TransformedDefinitionApiResponse | Nullish) => {
      store.setState({definition});
    },

    setApiError: (apiError: string | Nullish) => {
      store.setState({apiError});
    },

    initStaticConfig: (config: {
      gridCode: string;
      presetInstanceId?: string;
      disableAllActions?: boolean;
      hasSilentRefetching?: boolean;
      actionsAlignment?: ActionsAlignment;
    }) => {
      store.setState({
        gridCode: config.gridCode,
        presetDisplayModeOverride: loadPresetDisplayMode(config.gridCode),
        isVirtualPresetPinned: loadPinnedPresetIds(config.gridCode).has(VIRTUAL_PRESET_ID),
        presetInstanceId: config.presetInstanceId ?? null,
        disableAllActions: config.disableAllActions ?? false,
        hasSilentRefetching: config.hasSilentRefetching ?? false,
        actionsAlignment: config.actionsAlignment ?? null,
      });
    },
  };
}
